import React,{ Component } from 'react';
import $ from 'jquery';

class MainHeader extends Component {
	constructor(props) {
        super(props);
	 	this.state ={

	 	}
    }
	
	logout = () => {
        localStorage.removeItem('user_id');
        localStorage.removeItem('username');
		window.location = '/login';
    }
	
    render(){
        const {aopaOption}=this.props;
		let date = new Date();
		let newDate = ("0" + (date.getMonth() + 1)).slice(-2)+''+date.getDate()+''+date.getFullYear();
		let role = localStorage.getItem('role');
		let user_ip = localStorage.getItem('user_ip');

		return (
        <div className="card-header top-header">
            <div className="row">
				<div className="col-md-4 col-lg-6 col-3">
                    <h4>AOPA 2026</h4>
					<div className="instance-version">{'V1.06032026.a'}</div>
                </div>
				<div className="col-md-3 col-lg-2 col-6">
					<select id="select-view-option" className="form-control company-select" onChange={aopaOption} >
						<option value="explorer">AOPA Coding Pro</option>
						<option value="dataAdmin">Data Admin</option>
						<option value="userManager">User Manager</option>
					</select>
				</div>
                <div className="user-top-outer col-md-5 col-lg-4 col-3">
					{user_ip ? 
					<div className="user-ip">You are logged in from IP address: {user_ip}</div>
					:null}
					<div className="user-login-box">
						<div className="login-user-top text-right">
							<p className="mb-0 ">{'Welcome: '+localStorage.getItem('username')+'('+localStorage.getItem('role')+')'}</p>
						</div> 
						<div className="aa">
							<a className="nav-l1ink btn btn-outline-info sign-o1ut-btn btn-sm" onClick={this.logout}>Sign Out</a>
						</div>
					</div>
                </div>
            </div>
        </div>            
    )}
	
}

export default MainHeader;